import { Anchor, type _Navigation } from ":shared/components/route";
import { default as routes } from "../routes";
import IdleIcon from "../assets/icons/idle-folder.svg";
import ActiveIcon from "../assets/icons/active-folder.svg";
export default function Resources(props: _Navigation.SideNavJSXItemProps) {
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      components={{
        title: "Resources",
        idleIcon: <IdleIcon />,
        activeIcon: <ActiveIcon />,
      }}
    />
  );
}
